const PENDING_REQUESTS_CODE = 503
const EXPIRATION_TIMEOUT_IN_MINUTES = 10
const PENDING_REQUEST_CHECKING_INTERVAL = 10000

module.exports = {
  EXPIRATION_TIMEOUT_IN_MINUTES,
  PENDING_REQUESTS_CODE,
  PENDING_REQUEST_CHECKING_INTERVAL
}
